/**
 * Converts a number to a string and left-pads it with zeros to the specified length.
 * Example: leftPadWithZeros(123, 5) => '00123'
 *
 * @param num the number to convert to string and pad with zeros
 * @param length the desired length of the padded string
 * @returns {string} the padded number as string
 */
export const leftPadWithZeros = (num: number, length: number): string => {
  const text = num.toString();

  // Create a string of `0` as long as the desired length
  const padString = new Array(length).join('0');

  // Replace the last 0's in the string with `num`
  const padding = padString.substring(0, length - text.length);
  return padding + text;
};
